module.exports = __webpack_public_path__ + "img/SES_205410000.cc2757b3.jpg";